import { GetterTree } from 'vuex'
import { StatisticState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<StatisticState, RootState> = {
  pushStatisticDetail: state => state.pushStatisticDetail,
  pushStatisticDetailFlag: state => state.pushStatisticDetailFlag,

  pushStatisticGroup: state => state.pushStatisticGroup,
  pushGroupBy: state => state.pushGroupings.pushGroupBy,
  pushGroupByOptionally: state => state.pushGroupings.pushGroupByOptionally,
  pushMessageCount: state => state.pushMessageCount,
  pushIncomingGroupBy: state => state.pushGroupings.pushGroupIncoming,

  pushSubscribersCount: state => state.pushSubscribersCount || [],
  pushHistories: state => state.pushHistories || [],
};
